var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appContainer",class:{
    '--summary-active': _vm.$store.state.systemStore.summaryBehavior.showSummary
  },attrs:{"id":"app"}},[_c('AppCore',{ref:"appCore",attrs:{"appName":_vm.getAppName,"onlyLanguage":true,"showHeader":_vm.$store.getters.getShowHeader,"summaryBehavior":_vm.$store.state.systemStore.summaryBehavior,"onpopstateEnabled":false,"hideSummaryToggle":true},on:{"config-ready":_vm.loadApi}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }